import React from 'react';
import ListingStatus from '../../ListingStatus';
import './style.css';

const ListingBox = ({ listing, onClick }) => (
  <div className="teacher-listing-box btn-cursor px-4 py-3" onClick={() => onClick(listing.id)}>
    <div className="p-0 p-lg-3">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h5 className="m-0">{listing.service.description}</h5>
        <ListingStatus status={listing.status} />
      </div>
      <p className="teacher-listing-box__category m-0">{listing.service.category.description}</p>
    </div>
  </div>
);

export default ListingBox;



// WEBPACK FOOTER //
// ./src/pages/teacher/Schedule/Listings/Home/ListingBox/index.js